import { Vue } from 'vue-property-decorator';
import EventBus from '@/helpers/EventBus';
import LoginForm from '@/components/forms/LoginForm.vue';
import { languageItem } from '@/language/helpers';
import { openModal } from '@/modals/helpers/api';
export function openLoginModal() {
    return new Promise((resolve, reject) => {
        const t = languageItem('loginForm');
        const modals = Vue.prototype.$modals;
        openModal({
            component: LoginForm,
            name: 'login',
            title: t.title,
            size: 'sm',
            props: {
                showBecomeMemberLink: true,
            },
            closeOnBackdropClick: false,
        });
        // TODO Handle all dismiss/close events on the modal like this?
        // TODO
        EventBus.$on('tix:login:dismiss', () => {
            modals.close();
            reject();
        });
        EventBus.$on('tix:login:success', () => {
            modals.close();
            resolve();
        });
    });
}
